/** A member's short-lived TURN credentials, from the cloud's `GET /relay/turn/credentials`. */

import { z } from 'zod';

import { TurnCredentials as GeneratedTurnCredentialsSchema } from './generated/vms_database.zod';

export const TurnCredentialsSchema = GeneratedTurnCredentialsSchema.extend({
    /**
     * In RTCIceServer form (`turn:…?transport=…`), used as sent. An empty list would make
     * RTCPeerConnection refuse the whole configuration.
     */
    urls: z.array(z.string()).min(1),
});
export type TurnCredentials = z.infer<typeof TurnCredentialsSchema>;
